// extracted by mini-css-extract-plugin
export default {"note":"AppointmentSummaryNote_note__SVbXy","date-txt":"AppointmentSummaryNote_date-txt__7kM6K"};